import { initSentryBrowser } from '@nrx/error-tracking-web';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import App from './app.js';
import './index.css';

// Sentry must initialise before the app renders (mirrors ffs-signup and the backend
// instrument-first rule). Without this, every reportConsultError call and the app's error boundary
// are inert, and the Sentry ingest host the CDK stack's CSP allowlists is a destination nothing in
// the bundle can reach. No-op when VITE_SENTRY_DSN is unset, which is local dev.
initSentryBrowser({
  dsn: import.meta.env['VITE_SENTRY_DSN'],
  environment: import.meta.env['VITE_SENTRY_ENVIRONMENT'],
  release: import.meta.env['VITE_SENTRY_RELEASE'],
  app: 'consult',
});

// Consult scheduling — unauthenticated magic-link flow (mirrors ffs-signup): no auth provider,
// no Cognito. app.tsx ports the vendor's declarative <Routes> tree verbatim, which (like the
// vendor's own App.tsx) expects an ambient router context rather than providing its own —
// BrowserRouter here is that context, matching $OLD/src/main.tsx.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
